import { ApolloClient, ApolloProvider, from, InMemoryCache } from '@apollo/client'

import defaultOptions from './defaults'
import { authLink, errorLink, uploadLink } from './links'

export let client: ApolloClient<unknown>

export const GraphQLProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  client = new ApolloClient({
    cache: new InMemoryCache({
      addTypename: false,
    }),
    defaultOptions,
    link: from([errorLink(), authLink.concat(uploadLink)]),
  })

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
